import * as Vue from "vue";
import { getCurrentInstance, computed } from "vue";
import "./index-CgZzOVq6.js";
import { u as useListeners } from "./index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./index-BNd8MWnO.js";
import { u as useDisabledProp } from "./index-DKxr0Yto.js";
import "./index-vzP2cezV.js";
import { isVue2 } from "vue-demi";
import * as vueRouter from "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
function useContext() {
  return {
    isNuxt: Boolean((window == null ? void 0 : window.__NUXT__) || (window == null ? void 0 : window.$nuxt))
  };
}
function useLinkProps() {
  const TARGETS = ["_blank", "_self", "_parent", "_top", "framename"];
  function createLinkProps2({ defaultTo = "", defaultTarget = null } = {
    defaultTo: void 0,
    defaultTarget: void 0
  }) {
    return {
      to: {
        type: [String, Object],
        default: defaultTo
      },
      target: {
        type: String,
        default: defaultTarget,
        validator: (target) => TARGETS.includes(target)
      },
      external: {
        type: Boolean,
        default: false
      },
      native: {
        type: Boolean,
        default: false
      }
    };
  }
  function getLinkProps(props) {
    return {
      to: props.to,
      target: props.target,
      external: props.external,
      native: props.native
    };
  }
  return {
    TARGETS,
    createLinkProps: createLinkProps2,
    getLinkProps
  };
}
function resolveComponentVue2(name) {
  var _a, _b;
  return ((_b = (_a = Vue.default) == null ? void 0 : _a.options) == null ? void 0 : _b.components[name]) || name;
}
const useResolveComponent = isVue2 ? resolveComponentVue2 : Vue.resolveComponent;
const v2UseRouter = () => {
  const instance = getCurrentInstance();
  return instance.proxy.$router;
};
const useRouter = isVue2 ? v2UseRouter : vueRouter.useRouter;
const { createDisabledProp } = useDisabledProp();
const { createLinkProps } = useLinkProps();
const { createTestIdProp } = useDataTestIdProp();
const __default__ = {
  name: "BaseLink"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...createLinkProps(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const router = useRouter();
    const { isNuxt } = useContext();
    const { v2Listeners } = useListeners(["click"]);
    const hasRouter = computed(() => Boolean(router));
    const isInvalidUrl = computed(() => !props.to);
    const isCompleteUrl = computed(() => {
      try {
        return Boolean(new URL(props.to));
      } catch (e) {
        return false;
      }
    });
    const isExternalUrl = computed(() => {
      if (props.external) return true;
      if (isCompleteUrl.value) {
        const { origin: currentOrigin } = window.location;
        const { origin: linkOrigin } = new URL(props.to);
        return currentOrigin !== linkOrigin;
      }
      return false;
    });
    const isValidUrlToRouterLink = computed(() => !isExternalUrl.value && !isInvalidUrl.value);
    const canUseNuxt = computed(() => isNuxt && !props.native);
    const canUseRouterLink = computed(
      () => hasRouter.value && isValidUrlToRouterLink.value && !props.disabled && !props.native
    );
    const linkUrl = computed(() => {
      if (isCompleteUrl.value && !isExternalUrl.value) {
        const { origin } = window.location;
        return props.to.replace(origin, "");
      }
      return props.to;
    });
    const linkTag = computed(() => {
      if (canUseNuxt.value) {
        return useResolveComponent("NuxtLink");
      }
      if (canUseRouterLink.value) {
        return "router-link";
      }
      return "a";
    });
    const linkUrlAttr = computed(() => canUseRouterLink.value || canUseNuxt.value ? "to" : "href");
    const linkAttributes = computed(() => ({
      [linkUrlAttr.value]: linkUrl.value,
      rel: props.target === "_blank" ? "noopener noreferrer" : null,
      target: props.target,
      "aria-disabled": props.disabled,
      "data-testid": props.dataTestid
    }));
    function clickHandler(event) {
      if (props.disabled) {
        event.preventDefault();
      } else {
        if (isInvalidUrl.value) event.preventDefault();
        emit("click", event);
      }
    }
    return { __sfc: true, createDisabledProp, createLinkProps, createTestIdProp, props, emit, router, isNuxt, v2Listeners, hasRouter, isInvalidUrl, isCompleteUrl, isExternalUrl, isValidUrlToRouterLink, canUseNuxt, canUseRouterLink, linkUrl, linkTag, linkUrlAttr, linkAttributes, clickHandler };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.linkTag, _vm._g(_vm._b({ tag: "Component", on: { "click": _setup.clickHandler } }, "Component", _setup.linkAttributes, false), _setup.v2Listeners), [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null
);
const BaseLink = __component__.exports;
export {
  BaseLink as B,
  useLinkProps as u
};
